import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaSearch, FaTimes } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';
import DateTimePicker from 'react-datetime-picker';

import withRouter from '../../../util/WithRouter';
import Pages from '../../list/Pagination';
import ApiUiController from '../../../controller/ApiUiController';
import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';

class ApiLogList extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.data = { apis: [], count: 0 };
    this.pagination = { currentPage: 1, pageCount: 0, perPage: 10 };
    this.state = { from: null, to: null, search: '', inApiCall: true };
  }

  componentDidMount() {
    if (this.id) {
      this.loadData();
    }
  }

  loadData = () => {
    this.setState({ ...this.state, inApiCall: true });

    const date = this.state.from && this.state.to
      ? `${Util.dateToServerDateTime(this.state.from)}${Const.Opt}${Util.dateToServerDateTime(this.state.to)}` : '';

    const body = {
      id: this.id, date, search: this.state.search,
      page: this.pagination.currentPage, perPage: this.pagination.perPage
    };
    ThirdPartyAPI.logs(body, this.onApiReceived, this.onFail);
  };

  onApiReceived = res => {
    this.data = { apis: res.data, count: res.count };
    this.pagination = { ...this.pagination, pageCount: Math.ceil(res.count / this.pagination.perPage) };
    this.setState({ ...this.state, inApiCall: false });
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  clear = () => {
    this.pagination = { currentPage: 1, pageCount: 0, perPage: 10 };
    this.setState({ ...this.state, from: null, to: null, search: '', inApiCall: true });
    const body = {
      id: this.id, date: "", search: "",
      page: this.pagination.currentPage, perPage: this.pagination.perPage
    };
    ThirdPartyAPI.logs(body, this.onApiReceived, this.onFail);

  };

  onTextChanged = search => this.setState({ ...this.state, search });

  handleDateChange = (date, source) => {
    if (source === 'from') {
      if (date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
      }
      this.setState({ ...this.state, from: date });
    } else if (source === 'to') {
      if (date) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
      }
      this.setState({ ...this.state, to: date });
    }
  };

  onPageChange = currentPage => {
    this.pagination.currentPage = currentPage;
    this.loadData();
  };

  render() {
    const current = this.pagination.currentPage;
    const end = this.pagination.pageCount;

    const apiList = this.data.apis.map((api, i) =>
      <tr key={`api_${i}`}>
        <td>{i + 1}</td>
        <td>{Util.apochToDisplayDateTime(api.date_time)}</td>
        <td>{api.request ? JSON.stringify(api.request) : ''}</td>
        <td>{api.response ? JSON.stringify(api.response) : ''}</td>
        <td>{api.error ? JSON.stringify(api.error) : ''}</td>
      </tr>
    );

    return (
      <div>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="row">
                  <div className="col-md-9">
                    <Pages current={current} end={end} onPageChange={this.onPageChange} />
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="row">
                  <div className="col-md-12">
                    <span className="btn btn-lead btn-sm">Total : {this.data.count}</span>
                  </div>
                </div>
              </div>

              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-4">
                    From:
                    <DateTimePicker className="col-md-6"
                      onChange={date => this.handleDateChange(date, 'from')}
                      value={this.state.from}
                      format="dd-MM-y hh:mm a" />
                  </div>
                  <div className="col-md-4">
                    To:
                    <DateTimePicker className="col-md-6"
                      onChange={date => this.handleDateChange(date, 'to')}
                      value={this.state.to}
                      format="dd-MM-y hh:mm a" />
                  </div>
                  <div className="col-md-2">
                    <FormControl type="text" value={this.state.search} placeholder="Search Text"
                      onChange={event => this.onTextChanged(event.target.value)} />
                  </div>
                  <div className="col-md-1" onClick={this.loadData}><span><FaSearch /></span><span>Search</span></div>
                  <div className="col-md-1" onClick={this.clear}><span><FaTimes /></span><span>Clear</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-12">
              <ApiUiController inApiCall={this.state.inApiCall}>
                <Table striped bordered hover className="table-cursor">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Date Time</th>
                      <th>Request</th>
                      <th>Response</th>
                      <th>Error</th>
                    </tr>
                  </thead>
                  <tbody className="listlead">{apiList}</tbody>
                </Table>
              </ApiUiController>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ApiLogList);